import axios from '@/utils/api.request'
let previousUrl = '/api'

export const getUserInfo = (Token) => {
  return axios.request({
    url: `${previousUrl}/get_info`,
    // headers: {
    //   'userId': userId
    // },
    method: 'post'
  })
}
